import { gql } from '@apollo/client'
import { usePushPartialOnboardingMutation } from '@graphql/generated'

gql`
  mutation PushPartialOnboarding($input: OnboardPushPartialInput!) {
    onboardPushPartial(input: $input)
  }
`

interface PushPartialInput {
  orgName?: string
  email?: string
  phoneNumber?: string
}

export const usePushPartial = () => {
  const [pushPartial] = usePushPartialOnboardingMutation()

  const handlePushPartial = (input: PushPartialInput) => {
    pushPartial({
      variables: {
        input,
      },
    })
  }

  return {
    pushPartial: handlePushPartial,
  }
}
